export type NewsType = "新闻" | "活动" | "访谈";

export interface NewsItem {
  id: string;
  title: string;
  date: string;
  type: NewsType;
  summary: string;
  content: string[];
  image: string;
  tags: string[];
}

export const newsList: NewsItem[] = [
  {
    id: "news-tokyo-night",
    title: "佐佐木明希主演新剧《东京夜航》定档，挑战冷峻女检察官",
    date: "2026-09-28",
    type: "新闻",
    summary:
      "由佐佐木明希领衔主演的法律悬疑剧《东京夜航》正式宣布定档十月，她将在剧中饰演一位以冷静著称的女检察官白石凛。",
    content: [
      "由佐佐木明希领衔主演的法律悬疑剧《东京夜航》正式宣布定档十月，官方同步释出首支预告与主视觉海报。",
      "在本剧中，佐佐木明希饰演的女检察官白石凛以冷静与执着著称，面对一桩被长期搁置的旧案，她必须在真相与立场之间做出取舍。剧组透露，为了呈现更真实的职业质感，佐佐木明希提前两个月进入相关机构体验生活。",
      "导演在采访中表示，白石凛这个角色需要一个既克制又具有爆发力的表演者，而佐佐木明希在试镜时展现出的层次感让他毫不犹豫地确定了人选。",
      "《东京夜航》共十二集，将于十月起每周五晚间播出。",
    ],
    image:
      "https://readdy.ai/api/search-image?query=cinematic%20film%20poster%20style%20image%20of%20a%20confident%20East%20Asian%20woman%20in%20a%20tailored%20dark%20suit%20standing%20in%20a%20quiet%20modern%20courthouse%20corridor%2C%20cool%20muted%20neutral%20tones%2C%20soft%20diffused%20lighting%2C%20editorial%20magazine%20photography%2C%20shallow%20depth%20of%20field&width=800&height=600&seq=news-tokyo-night-01&orientation=landscape",
    tags: ["东京夜航", "定档", "电视剧"],
  },
  {
    id: "news-snow-premiere",
    title: "电影《雪之记忆》首映礼落幕，佐佐木明希红毯造型获赞",
    date: "2026-09-20",
    type: "活动",
    summary:
      "电影《雪之记忆》在东京举行首映礼，佐佐木明希一袭深蓝色长裙亮相红毯，现场氛围温暖而克制。",
    content: [
      "电影《雪之记忆》在东京举行首映礼，主创团队悉数亮相，与到场观众分享了拍摄期间的幕后故事。",
      "佐佐木明希一袭深蓝色长裙亮相红毯，造型简洁而富于质感，被现场媒体评价为当晚最具编辑感的一次出场。她在采访中提到，影片中大量的雪景戏份在低温环境下完成，是对体能与情绪的双重考验。",
      "首映结束后，观众给予了长时间掌声。《雪之记忆》将于下月正式公映。",
    ],
    image:
      "https://readdy.ai/api/search-image?query=elegant%20East%20Asian%20woman%20in%20a%20deep%20blue%20floor%20length%20gown%20on%20a%20minimal%20premiere%20red%20carpet%2C%20soft%20warm%20spotlights%2C%20muted%20neutral%20background%20with%20subtle%20bokeh%2C%20fashion%20editorial%20photography%2C%20refined%20and%20calm&width=800&height=600&seq=news-snow-premiere-01&orientation=landscape",
    tags: ["雪之记忆", "首映礼", "活动"],
  },
  {
    id: "news-interview-tenyears",
    title: "专访：佐佐木明希谈十年演艺路与表演的孤独",
    date: "2026-09-15",
    type: "访谈",
    summary:
      "出道十年，佐佐木明希在访谈中回顾了自己的表演轨迹，并坦言表演是一场需要长期忍受孤独的自我对话。",
    content: [
      "出道十年，佐佐木明希在一场长达两小时的访谈中回顾了自己的表演轨迹。",
      "她坦言，表演是一场需要长期忍受孤独的自我对话。每当接到一个新角色，她都会用大量时间独处，去理解这个人物的呼吸与沉默。",
      "谈到未来，她表示希望尝试更多具有作者气质的作品，也期待有一天能参与剧本阶段的创作。",
    ],
    image:
      "https://readdy.ai/api/search-image?query=intimate%20editorial%20interview%20portrait%20of%20an%20elegant%20East%20Asian%20woman%20with%20long%20dark%20hair%20seated%20in%20a%20quiet%20warm%20lit%20room%2C%20soft%20diffused%20window%20light%2C%20muted%20beige%20background%2C%20magazine%20photography%2C%20thoughtful%20expression&width=800&height=600&seq=news-interview-01&orientation=landscape",
    tags: ["访谈", "十年", "表演"],
  },
  {
    id: "news-rating-boost",
    title: "《东京夜航》收视破十，制作方宣布加拍特别篇",
    date: "2026-09-10",
    type: "新闻",
    summary:
      "《东京夜航》播出后收视持续走高并突破十点，制作方宣布将加拍一集特别篇以回应观众热情。",
    content: [
      "《东京夜航》播出后收视持续走高，第三集播出后正式突破十点，成为本季度讨论度最高的剧集之一。",
      "制作方宣布将加拍一集特别篇，进一步补完白石凛这一角色的前史。佐佐木明希表示，特别篇会让观众更理解这个人物冷静外表下的动机。",
    ],
    image:
      "https://readdy.ai/api/search-image?query=moody%20nighttime%20city%20skyline%20of%20Tokyo%20seen%20through%20rain%20streaked%20glass%2C%20cool%20muted%20neutral%20tones%2C%20cinematic%20soft%20lighting%2C%20editorial%20photography%2C%20atmospheric%20and%20quiet&width=800&height=600&seq=news-rating-01&orientation=landscape",
    tags: ["东京夜航", "收视", "特别篇"],
  },
  {
    id: "news-okinawa-jury",
    title: "佐佐木明希受邀担任冲绳电影节评审",
    date: "2026-08-30",
    type: "活动",
    summary:
      "佐佐木明希确认受邀担任冲绳电影节竞赛单元评审，她表示会以观众的直觉与从业者的经验并重来观看作品。",
    content: [
      "佐佐木明希确认受邀担任冲绳电影节竞赛单元评审，与多位国际影人共同评选年度短片作品。",
      "她表示，评审工作让她第一次以完全不同的角度重新观看电影，会以观众的直觉与从业者的经验并重来做出判断。",
    ],
    image:
      "https://readdy.ai/api/search-image?query=elegant%20East%20Asian%20woman%20in%20a%20light%20linen%20blazer%20standing%20by%20a%20sunlit%20coastal%20terrace%2C%20soft%20natural%20daylight%2C%20muted%20neutral%20tones%2C%20travel%20editorial%20photography%2C%20calm%20and%20graceful&width=800&height=600&seq=news-okinawa-01&orientation=landscape",
    tags: ["冲绳电影节", "评审", "活动"],
  },
  {
    id: "news-silent-coast-nominee",
    title: "《寂静海岸》获釜山国际电影节提名",
    date: "2026-08-22",
    type: "新闻",
    summary:
      "佐佐木明希主演的《寂静海岸》入围釜山国际电影节新浪潮单元，影评人称其表演克制而富有余韵。",
    content: [
      "佐佐木明希主演的《寂静海岸》入围釜山国际电影节新浪潮单元，这也是她第二次携作品登上该影展。",
      "影评人评价她在片中几乎没有大段台词，却用眼神与身体完成了一场完整的情绪弧线，表演克制而富有余韵。",
    ],
    image:
      "https://readdy.ai/api/search-image?query=serene%20empty%20coastline%20at%20dusk%20with%20calm%20lapping%20waves%20and%20soft%20overcast%20sky%2C%20muted%20cool%20neutral%20tones%2C%20minimal%20cinematic%20composition%2C%20editorial%20photography%2C%20quiet%20atmosphere&width=800&height=600&seq=news-busan-01&orientation=landscape",
    tags: ["寂静海岸", "釜山", "提名"],
  },
  {
    id: "news-stage-to-screen",
    title: "访谈：从舞台剧到银幕，佐佐木明希的转型心得",
    date: "2026-08-14",
    type: "访谈",
    summary:
      "佐佐木明希聊起从舞台剧出身到银幕表演的转型，认为两者最大的差别在于节奏与距离感。",
    content: [
      "佐佐木明希聊起从舞台剧出身到银幕表演的转型，认为两者最大的差别在于节奏与距离感。",
      "她说舞台要求表演被最后一排观众接住，而镜头则要求一切向内收敛。这些年她一直在练习把情绪压得更低、更细。",
    ],
    image:
      "https://readdy.ai/api/search-image?query=an%20empty%20classic%20theatre%20stage%20with%20a%20single%20warm%20spotlight%20and%20muted%20dark%20curtains%2C%20soft%20diffused%20lighting%2C%20muted%20neutral%20tones%2C%20editorial%20photography%2C%20quiet%20and%20dramatic&width=800&height=600&seq=news-stage-01&orientation=landscape",
    tags: ["访谈", "舞台剧", "转型"],
  },
  {
    id: "news-photobook",
    title: "佐佐木明希新写真集《光与影》正式发售",
    date: "2026-08-05",
    type: "新闻",
    summary:
      "全新写真集《光与影》正式发售，全书以自然光为线索，记录了佐佐木明希在海岸与老城街巷间的多组影像。",
    content: [
      "全新写真集《光与影》正式发售，全书以自然光为线索，记录了佐佐木明希在海岸与老城街巷间的多组影像。",
      "据出版方介绍，本组作品大量使用清晨与黄昏的柔和光线，希望呈现一种不刻意修饰的松弛感。",
    ],
    image:
      "https://readdy.ai/api/search-image?query=soft%20natural%20light%20editorial%20portrait%20of%20an%20elegant%20East%20Asian%20woman%20in%20a%20linen%20shirt%20leaning%20against%20an%20old%20stone%20wall%2C%20warm%20afternoon%20sunlight%2C%20muted%20beige%20tones%2C%20magazine%20photography%2C%20relaxed%20expression&width=800&height=600&seq=news-photobook-01&orientation=landscape",
    tags: ["写真集", "光与影", "发售"],
  },
  {
    id: "news-asian-awards",
    title: "《雪之记忆》入围亚洲电影大奖最佳女主角",
    date: "2026-07-28",
    type: "新闻",
    summary:
      "佐佐木明希凭借《雪之记忆》入围亚洲电影大奖最佳女主角，这是她职业生涯中的第三次影后提名。",
    content: [
      "佐佐木明希凭借《雪之记忆》入围亚洲电影大奖最佳女主角，这是她职业生涯中的第三次影后提名。",
      "在片中，她饰演的高桥雪为了兑现一个旧日承诺，独自踏上了一段漫长而安静的旅程。评审团评价这一角色兼具脆弱与坚定。",
    ],
    image:
      "https://readdy.ai/api/search-image?query=elegant%20East%20Asian%20woman%20in%20a%20soft%20ivory%20knit%20dress%20standing%20in%20falling%20snow%2C%20soft%20diffused%20cold%20light%2C%20muted%20cool%20neutral%20background%2C%20cinematic%20editorial%20photography%2C%20serene%20expression&width=800&height=600&seq=news-awards-01&orientation=landscape",
    tags: ["雪之记忆", "亚洲电影大奖", "提名"],
  },
  {
    id: "news-fashion-show",
    title: "佐佐木明希出席品牌秋冬大秀",
    date: "2026-07-19",
    type: "活动",
    summary:
      "佐佐木明希受邀出席某品牌秋冬系列大秀，一身极简黑色造型成为当日镜头焦点。",
    content: [
      "佐佐木明希受邀出席某品牌秋冬系列大秀，一身极简黑色造型成为当日镜头焦点。",
      "她在后台与设计师短暂交流，谈到自己偏爱线条利落、质感克制的服装，因为这类风格更能让人物本身被看见。",
    ],
    image:
      "https://readdy.ai/api/search-image?query=elegant%20East%20Asian%20woman%20in%20a%20minimal%20structured%20black%20coat%20at%20a%20fashion%20show%20venue%2C%20soft%20warm%20ambient%20lighting%2C%20muted%20neutral%20tones%2C%20high%20fashion%20editorial%20photography%2C%20composed%20expression&width=800&height=600&seq=news-fashion-01&orientation=landscape",
    tags: ["时装周", "秋冬大秀", "活动"],
  },
  {
    id: "news-spring-mail",
    title: "经典剧集《春日邮便》宣布重制，佐佐木明希回归客串",
    date: "2026-07-08",
    type: "新闻",
    summary:
      "曾让佐佐木明希被更多观众记住的《春日邮便》宣布重制，她将在新版中以客串身份回归。",
    content: [
      "曾让佐佐木明希被更多观众记住的《春日邮便》宣布重制，她将在新版中以客串身份回归。",
      "她表示，回到这个故事像是一次与旧友的重逢，也让自己重新看见当初那个对表演一无所知却充满热情的自己。",
    ],
    image:
      "https://readdy.ai/api/search-image?query=a%20quiet%20countryside%20post%20office%20with%20pastel%20mailboxes%20and%20blooming%20cherry%20branches%2C%20soft%20spring%20daylight%2C%20muted%20warm%20neutral%20tones%2C%20nostalgic%20editorial%20photography%2C%20gentle%20atmosphere&width=800&height=600&seq=news-spring-01&orientation=landscape",
    tags: ["春日邮便", "重制", "客串"],
  },
  {
    id: "news-silent-cry",
    title: "访谈：关于《寂静海岸》中那场无声的哭戏",
    date: "2026-06-30",
    type: "访谈",
    summary:
      "佐佐木明希细致回忆起《寂静海岸》里那场没有台词、只有呼吸的哭戏，称那是一次完全交给身体的表演。",
    content: [
      "佐佐木明希细致回忆起《寂静海岸》里那场没有台词、只有呼吸的哭戏。",
      "她说导演只给了一个提示——不要哭出来。于是她把所有情绪都压在喉咙里，只用呼吸和肩膀的颤动去完成。那一条一次通过。",
    ],
    image:
      "https://readdy.ai/api/search-image?query=close%20up%20cinematic%20portrait%20of%20an%20elegant%20East%20Asian%20woman%20with%20restrained%20emotional%20expression%2C%20soft%20diffused%20low%20light%2C%20muted%20cool%20neutral%20background%2C%20editorial%20photography%2C%20intimate%20and%20quiet&width=800&height=600&seq=news-cry-01&orientation=landscape",
    tags: ["寂静海岸", "访谈", "表演"],
  },
];